import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Объединяет classNames с дедупликацией Tailwind-утилит. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
